import React, { useEffect, useState } from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import PaperCard from "@/components/PaperCard";
import api from "@/lib/api";
import { Search } from "lucide-react";

const DOMAINS = ["All", "AI/ML", "Computer Science", "NLP", "Public Health", "Medical Sciences",
  "Climate Science", "Environment", "Civil Engineering", "Economics", "Education", "Social Sciences"];

export default function PublishedPapers() {
  const [papers, setPapers] = useState([]);
  const [q, setQ] = useState("");
  const [domain, setDomain] = useState("All");
  const [year, setYear] = useState("");
  const [loading, setLoading] = useState(true);

  const loadPapers = async () => {
    setLoading(true);
    const params = {};
    if (q) params.q = q;
    if (domain !== "All") params.domain = domain;
    if (year) params.year = Number(year);
    const r = await api.get("/papers", { params });
    setPapers(r.data);
    setLoading(false);
  };

  useEffect(() => { loadPapers(); /* eslint-disable-next-line */ }, [domain, year]);
  useEffect(() => { const t = setTimeout(loadPapers, 250); return () => clearTimeout(t); /* eslint-disable-next-line */ }, [q]);

  return (
    <div className="min-h-screen bg-kb-bg" data-testid="publications-page">
      <Navbar />

      <section className="max-w-7xl mx-auto px-6 lg:px-10 pt-20 pb-10 lg:pt-28">
        <div className="kb-mono text-[10px] uppercase tracking-[0.2em] text-kb-ink-muted mb-4">PUBLISHED RESEARCH</div>
        <h1 className="font-serif text-5xl sm:text-6xl text-kb-ink leading-[1.05] max-w-3xl">
          Research that <em className="italic text-kb-primary">left the lab</em>.
        </h1>
        <p className="mt-6 text-lg text-kb-ink-muted max-w-2xl">
          A growing archive of papers produced and supported through the KhojByte ecosystem — peer-reviewed, indexed, and openly indexed for impact.
        </p>
      </section>

      <section className="max-w-7xl mx-auto px-6 lg:px-10 pb-8">
        <div className="grid lg:grid-cols-12 gap-3">
          <div className="lg:col-span-6 relative">
            <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-kb-ink-light" />
            <input className="kb-input pl-9" placeholder="Search title, abstract, author or venue…"
              value={q} onChange={(e) => setQ(e.target.value)} data-testid="papers-search-input" />
          </div>
          <div className="lg:col-span-4">
            <select className="kb-input" value={domain} onChange={(e) => setDomain(e.target.value)} data-testid="papers-domain-select">
              {DOMAINS.map((d) => <option key={d} value={d}>{d}</option>)}
            </select>
          </div>
          <div className="lg:col-span-2">
            <input type="number" placeholder="Year" className="kb-input" value={year}
              onChange={(e) => setYear(e.target.value)} data-testid="papers-year-input" />
          </div>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 lg:px-10 pb-24">
        {loading ? (
          <div className="kb-mono text-xs text-kb-ink-muted">Loading papers…</div>
        ) : papers.length === 0 ? (
          <div className="text-center py-20 border border-dashed border-slate-300 rounded-sm bg-white text-sm text-kb-ink-muted">
            No papers match your filters.
          </div>
        ) : (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 stagger-in">
            {papers.map((p) => <PaperCard key={p.id} paper={p} />)}
          </div>
        )}
      </section>

      <Footer />
    </div>
  );
}
